<template>
  <div class="declareDefine">
    <div class="declare-define-header">
      <div class="define-header">
        <span class="title">申报定义</span>
        <div class="define-header-box">
          <span>是否公开</span>
          <div class="select-button" @click="changePublish">
            <span :class="publishSelect[0]?'active':'none'">是</span>
            <span :class="publishSelect[1]? 'active': 'none'">否</span>
          </div>
        </div>
        <div class="btn">
          <el-button ref="save" @click="save">保存</el-button>
          <div class="del">
            <el-dropdown trigger="click">
              <img src="../../../assets/image/examinationMan/merge-icon.png" alt />
              <el-dropdown-menu slot="dropdown" style="top:150px;left:1150px;">
                <el-button @click="deleteShow">删除</el-button>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="define-content">
        <div class="define-box">
          <div class="con-box">
            <div class="title">申报名称</div>
            <el-input
              v-model="declareName"
              maxlength="30"
              style="width:699px;margin-right:0;"
              placeholder="最多30个字"
            ></el-input>
          </div>
          <div class="con-box">
            <div class="title">时间范围</div>
            <el-date-picker
              style="margin-right: 20px"
              unlink-panels
              v-model="dataTime"
              :default-time="['00:00:00', '23:59:59']"
              value-format="timestamp"
              type="daterange"
              range-separator="至"
              @change="getDataTime"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <span style="margin-left: -14px;padding-right: 20px;font-size: 20px;color: #409EFF">
              <el-tooltip class="item" effect="light" content="时间范围：对指定时间范围内的表现进行申报" placement="top-start">
              <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
            <div class="title">申报对象</div>
            <el-select
              v-model="declareObject"
              multiple
              filterable
              :multiple-limit="5"
              placeholder="请选择"
            >
              <el-option
                v-for="(item,key) in declareObjectList"
                :key="key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="con-box">
            <div class="title">活动项目</div>
            <el-select
              v-model="activityRangeValue"
              multiple
              filterable
              placeholder="请选择"
              style="margin-right:40px;"
            >
              <el-option
                v-for="(item,itemKey) in activityRange"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
            <div class="title" style="margin-left: 6px">说明</div>
            <el-input
              style="margin-right:0;"
              maxlength="200"
              v-model="descriptionValue"
              placeholder="最多200个字"
            ></el-input>
          </div>
        </div>
      </div>
      <el-dialog title="提示" :visible.sync="isDelActivity" center>
        <span>确定删除本次活动定义吗?</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isDelActivity = false;deleteBtn = false">取 消</el-button>
          <el-button type="primary" @click="isDelActivityed">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div style="position: relative">
      <publicDefine
              :oldContent="oldContent"
              @watchDeclareContentPostMessage="watchDeclareContentPostMessage"
      ></publicDefine>
      <div class="slot-text" v-show="showText">
        <div class="slot-message">已有用户提交申报无法修改申报项目</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "declareDefine",
  components: {
    publicDefine: () => import("./public/publicDefine.vue")
  },
  watch: {
    $route(to, from) {
      if (to.query.id === "") {
        this.declareName = "";
        this.dataTime = [];
        this.declareObject = [];
        this.activityRangeValue = [];
        this.descriptionValue = "";
        this.id = to.query.id;
        this.showText = false;
        this.oldContent = "";
      } else {
        this.getDeclareDefineById(this.$route.query.id).then(res => {
          this.oldContent = "";
          this.oldContent = res;
        });
      }
    }
  },
  data() {
    return {
      selectList: [true, false],
      declareObjectList: [],
      value: "",
      textarea: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      dataTime: "",
      declareObject: [],
      activityRange: [],
      activityRangeValue: [],
      descriptionValue: "",
      declareName: "",
      content: [],
      id: "",
      isDelActivity: false,
      oldContent: "",
      publishSelect: [true, false],
      version: null,
      deleteBtn: false,
      showText: false,
      declareContent:[]
    };
  },
  created() {},
  methods: {
    getDataTime(value) {},
    getDeclareRoles() {
      this.declareObjectList = [];
      return this.$https
        .get("/api/blog/eRate/getDeclareRoles")
        .then(res => {
          res.data.forEach((item, key) => {
            this.declareObjectList.push({
              label: item.name,
              value: key + "",
              id: item.id
            });
          });
        })
        .catch(err => {});
    },
    // 删除
    delActivity() {
      this.deleteBtn = true;
    },
    deleteShow() {
      // this.isDelActivity = true;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$https
            .post("/api/blog/eRate/deleteDeclareDefine", {
              id: this.id
            })
            .then(res => {
              this.isDelActivity = false;
              this.$notify({
                title: "删除成功",
                type: "success"
              });
              this.deleteBtn = false;
              this.$store.dispatch("contentChangeDeclareState");
              this.declareName = "";
              this.dataTime = [];
              this.declareObject = [];
              this.activityRangeValue = [];
              this.descriptionValue = "";
            })
            .catch(error => {
              this.$notify.error({
                title: "删除失败",
                message: error.data.message
              });
              this.deleteBtn = false;
              this.isDelActivity = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 确定删除
    isDelActivityed() {
      this.$https
        .post("/api/blog/eRate/deleteDeclareDefine", {
          id: this.id
        })
        .then(res => {
          this.isDelActivity = false;
          this.$notify({
            title: "删除成功",
            type: "success"
          });
          this.deleteBtn = false;
          this.$store.dispatch("contentChangeDeclareState");
          this.declareName = "";
          this.dataTime = [];
          this.declareObject = [];
          this.activityRangeValue = [];
          this.descriptionValue = "";
        })
        .catch(error => {
          this.$notify.error({
            title: "删除失败",
            message: error.data.message
          });
          this.deleteBtn = false;
          this.isDelActivity = false;
        });
    },
    getDeclareDefineById(id) {
      return this.$https
        .get("/api/blog/eRate/getDeclareDefineById", {
          params: {
            id: id
          }
        })
        .then(res => {
          let data = res.data;
          let arr = [data.startTime, data.endTime];
          this.dataTime = arr;
          this.declareName = data.name;
          this.descriptionValue = data.description;
          this.declareObject = [];
          this.activityRangeValue = [];
          this.content = res.data.content;
          this.declareObjectList.forEach((declareItem, declareKey) => {
            data.roleIds.forEach((item, key) => {
              if (declareItem.id === item) {
                this.declareObject.push(declareItem.value);
              }
            });
          });
          this.activityRangeValue = data.activityDefineIds;
          return res.data.content;
        })
        .catch(err => {});
    },
    getAllActivityDefine() {
      this.activityRange = [];
      return this.$https
        .get("/api/blog/eRate/getAllActivityDefine", {
          params: {
            all: true
          }
        })
        .then(res => {
          this.activityRange = [];
          res.data.forEach((item, itemKey) => {
            this.activityRange.push({
              label: item.name,
              value: itemKey,
              id: item.id
            });
          });
        })
        .catch(error => {});
    },
    selectIng() {
      let arr = [];
      this.selectList.forEach(item => {
        arr.push(!item);
      });
      this.selectList = [];
      this.selectList = arr;
    },
    watchDeclareContentPostMessage(content) {
      this.declareContent = content;
    },
    save() {
      setTimeout(() => {
        document.activeElement.blur();
      }, 500);
      if (this.declareName === "") {
        this.$notify.error({
          title: "请输入申报名称"
        });
        return;
      }
      if (this.declareObject.length === 0) {
        this.$notify.error({
          title: "请选择申报对象"
        });
        return;
      }
      if (!this.dataTime.length) {
        this.$notify.error({
          title: "请输入申报时间"
        });
        return;
      }
      if (this.activityRangeValue === []) {
        this.$notify.error({
          title: "请输入申报对象"
        });
        return;
      }
      // 审核人
      let roleIds = [];
      this.declareObject.forEach((item, key) => {
        roleIds.push(this.declareObjectList[Number(item)].id);
      });
      let startTime = this.dataTime[0];
      let endTime = this.dataTime[1];
      // 活动范围
      let activityDefineIds = this.activityRangeValue;
      this.declareContent = {
        result: this.declareContent,
        children: []
      };
      let by = true;
      let str = "";
      if (typeof this.declareContent.result === "string") {
        this.declareContent.result = JSON.parse(this.declareContent.result).result;
      }
      this.declareContent.result.forEach(item => {
        if (item.interface === "singlebox" || item.interface === "checkbox") {
          if (item.declareContent === "") {
            by = false;
            str = item.label;
          }
        }
      });
      if (!by) {
        this.$notify.error({
          title: `请填写${str}中的选项`
        });
        return;
      }
      let obj = {
        name: this.declareName,
        roleIds,
        startTime,
        endTime,
        activityDefineIds,
        description: this.descriptionValue,
        content: JSON.stringify(this.declareContent),
        publish: this.publishSelect[0]
      };
      if (this.id.length !== 0) {
        obj.id = this.id;
        // 更新申报
        this.$https
          .post("/api/blog/eRate/saveDeclareDefine", obj)
          .then(res => {
            if (!res.data) return;

            this.id = res.data.id;
            this.$store.dispatch("contentChangeDeclareState");
            this.$notify({
              title: "更新成功",
              type: "success"
            });
            location.reload();
            return res.data;
          })
          .catch(error => {
            this.$notify.error({
              title: "更新失败",
              message: error.data.message
            });
          });
      } else {
        // 保存申报
        this.$https
          .post("/api/blog/eRate/saveDeclareDefine", obj)
          .then(res => {
            this.id = res.data.id;
            this.$store.dispatch("contentChangeDeclareState");
            this.$notify({
              title: "保存成功",
              type: "success"
            });
            location.reload();
            // this.$router.push('/declareShow');
            return res.data;
          })
          .catch(error => {
            this.$notify.error({
              title: "保存失败",
              message: error.data.message
            });
          });
      }
    },
    release() {
      this.$https
        .post("/api/blog/eRate/publishDeclareDefine", {
          id: this.id,
          publish: true
        })
        .then(res => {
          this.$notify({
            title: "发布成功",
            type: "success"
          });
        })
        .catch(err => {
          this.$notify.error({
            title: "发布失败"
          });
        });
    },
    parseTime(d) {
      d = new Date(d).getTime();
      return d;
    },
    changePublish() {
      let arr = [];
      this.publishSelect.forEach(item => {
        arr.push(!item);
      });
      this.publishSelect = [];
      this.publishSelect = arr;
    },
    judgeTime(dateTime) {
      let year = new Date(datetime).getFullYear();
      let mounth = new Date(datetime).getMonth() + 1;
      let date = new Date(datetime).getDate();
      return year + "年" + mounth + "月" + date + "日";
    }
  },
  activated() {
    if (this.$route.query.id === "") {
      this.oldContent = "";
      this.getAllActivityDefine();
      this.getDeclareRoles();
    } else {
      this.id = this.$route.query.id;
      this.getAllActivityDefine().then(res => {
        this.getDeclareRoles().then(res => {
          this.getDeclareDefineById(this.$route.query.id).then(res => {
            this.oldContent = "";
            this.oldContent = res;
          });
        });
      });
    }
    if (this.$route.query.id) {
      this.$https
              .get("/api/blog/eRate/countParticipantByDeclareDefineId", {
                params: {
                  id: this.id
                }
              })
              .then(res => {
                if (res.data.declareNum > 0) {
                  this.showText = true;
                }else {
                  this.showText = false;
                }
              })
              .catch(error => {
                this.$notify.error({
                  title: '错误',
                  message: error.message || error.data.message,
                  offset: 50
                });
              });
    }
  }
};
</script>
<style lang="scss" scoped>
.declareDefine {
  position: relative;
}
.define-header {
  padding: 19px 33px 29px 23px;
  .title {
    color: #333333;
    font-size: 23px;
    font-weight: bold;
    line-height: 31px;
    display: inline-block;
  }
  .btn {
    float: right;
  }
  .define-header-box {
    display: inline-block;
    margin-left: 31px;
    margin-top: -3px;
    span {
      color: #333333;
      position: relative;
    }
  }
  .del {
    display: inline-block;
    margin-left: 17px;
    position: relative;
    top: 2px;
    cursor: pointer;
  }
  .el-button--default,
  .el-button--primary {
    width: 100px;
    margin-left: 15px;
    padding: 0;
    line-height: 31px;
  }
  .el-button--default {
    border: 1px solid #2196f3;
    color: #2196f3;
  }
}
.activityDefine {
  overflow: hidden;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 17px 0px rgba(254, 253, 253, 0.02);
  border-radius: 15px;
  .define-content {
    padding: 19px 33px 29px 25px;
    .con-box {
      display: inline-block;
      margin-right: 45px;
      .title {
        display: inline-block;
        margin-right: 15px;
        line-height: 27px;
        position: relative;
        font-weight: bold;
        text-align: right;
        width: 58px;
      }
      .select-button {
        background: #ececec;
        display: inline-block;
        border-radius: 13px;
        overflow: hidden;
        cursor: pointer;
        position: relative;
        top: 7px;
        span {
          display: inline-block;
          color: #666;
          margin: 0;
          background: #ececec;
          line-height: 21px;
          padding: 3px 20px;
        }
        .active {
          color: #fff;
          background: #2196f3;
          border-radius: 13px;
        }
      }
      .el-input {
        position: relative;
      }
    }
  }
}
.declareDefine {
  overflow: hidden;
  // background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 17px 0px rgba(254, 253, 253, 0.02);
  border-radius: 15px;
  .define-content {
    padding: 19px 33px 29px 23px;
    .con-box {
      display: inline-block;
      margin-bottom: 10px;
      .title {
        display: inline-block;
        margin-right: 15px;
        line-height: 27px;
        position: relative;
        font-weight: bold;
        text-align: right;
        width: 58px;
      }
      .select-button {
        background: #ececec;
        display: inline-block;
        border-radius: 13px;
        overflow: hidden;
        cursor: pointer;
        position: relative;
        top: 7px;
        span {
          display: inline-block;
          color: #666;
          margin: 0;
          background: #ececec;
          line-height: 21px;
          padding: 3px 20px;
        }
        .active {
          color: #fff;
          background: #2196f3;
          border-radius: 13px;
        }
      }
      .el-input {
        margin-right: 40px;
        position: relative;
      }
    }
  }
}
.activityDefine .con-box /deep/ .el-input {
  // height: 33px;
  width: 353px;
}
.declareDefine .con-box /deep/ .el-input {
  // height: 33px;
  width: 290px;
}
.actityDetails {
  padding: 21px 25px;
  background: #fff;
  margin-top: 33px;
  border-radius: 15px;
  .define-header {
    span {
      color: #333333;
      font-size: 23px;
      font-weight: bold;
      line-height: 31px;
      display: inline-block;
    }
  }
  .actitiy-content {
    display: flex;
  }
  .actityLeft {
    display: inline-block;
    .actityLeftHeader {
      margin-top: 15px;
    }
    .actityLeftContent {
      width: 278px;
      height: 513px;
      box-shadow: 0px 0px 12px -5px rgba(0, 0, 0, 0.13),
        0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      border-radius: 23px;
      margin-top: 30px;
      overflow: hidden;
      .content-bar {
        width: 148px;
        height: 6px;
        background: rgba(192, 192, 192, 1);
        border-radius: 4px;
        margin: 4px auto;
      }
      .content-box {
        width: 263px;
        height: 493px;
        background: rgba(192, 192, 192, 1);
        border-radius: 16px;
        margin: 0 auto;
        span {
          color: #373737;
          font-size: 14px;
          font-weight: bold;
        }
        .box-header {
          padding-top: 32px;
          padding-left: 10px;
          padding-bottom: 20px;
        }
        .boxList {
          padding: 0 2px;
          position: relative;
          .box-item {
            margin-bottom: 10px;
            background: #fff;
            line-height: 35px;
            padding-left: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .actityRight {
    display: inline-block;
    margin-left: 95px;
    .header {
      .title {
        color: #333333;
        font-size: 14px;
        font-weight: bold;
      }
      .message {
        font-size: 10px;
        color: #979797;
        margin-left: 10px;
      }
    }
    .el-input {
      width: 333px;
      margin-top: 6px;
    }
    .content {
      margin-top: 23px;
      .title {
        color: #333333;
        font-size: 14px;
        font-weight: bold;
        margin-right: 10px;
        line-height: 27px;
        display: inline-block;
        position: relative;
        top: -8px;
      }
      .select-button {
        background: #ececec;
        display: inline-block;
        border-radius: 13px;
        overflow: hidden;
        cursor: pointer;
        span {
          display: inline-block;
          color: #666;
          background: #ececec;
          line-height: 21px;
          padding: 3px 20px;
        }
        .active {
          color: #fff;
          background: #2196f3;
          border-radius: 13px;
        }
      }
    }
    .option {
      margin-top: 20px;
    }
  }
}
.con-box /deep/ .el-select {
  .el-select__tags {
    top: 3px;
    transform: translateY(0);
    .el-tag--light {
      background: rgba(230, 244, 255, 1);
      border-radius: 14px;
      .el-select__tags-text {
        color: #2196f3ff;
      }
      .el-icon-close {
        background: #a9d9ffff;
        color: #2196f3ff;
      }
    }
  }
}
.el-range-editor {
  // height: 31px;
  width: 290px;
  margin-right: 40px;
  .el-range-separator {
    display: inline-block;
    padding: 0;
    line-height: 26px;
  }
  .el-range__icon {
    // line-height: 26px !important;
  }
  .el-range-input {
    margin-top: 3px;
  }
}
.select-button {
  background: #ececec;
  display: inline-block;
  border-radius: 13px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  top: 7px;
  margin-left: 15px;
  span {
    display: inline-block;
    color: #666;
    margin: 0;
    background: #ececec;
    line-height: 21px;
    padding: 3px 20px;
  }
  .active {
    background: #2196f3;
    border-radius: 13px;
    color: #fff !important;
  }
}
.el-popper {
  border: 0;
  margin: 0;
  padding: 0;
}
.el-popper /deep/ .popper__arrow {
  display: none;
}
.slot-text {
  width: 780px;
  height: 810px;
  top: 25px;
  left: 10px;
  background: #fff;
  z-index: 99;
  position: absolute;
  opacity: 0.8;
  .slot-message {
    color: #ff8153;
    font-weight: 600;
    font-size: 26px;
    text-align: center;
    width: 228px;
    padding-left: 290px;
    display: inline-block;
    padding-top: 210px;
  }
}
.declare-define-header {
  background: #fff;
  border-radius: 15px;
}
</style>
